<template>
    <o-field horizontal :label="label">
        <o-skeleton v-if="loading"></o-skeleton>
        <div v-else>
            <p v-if="html" v-html="html" style="width: 100%"></p>
            <a v-else-if="href" class="field" target="_blank" :href="$filters.WebAddress(href)">
                {{ value }}
            </a>
            <router-link v-else-if="to" :to="to">
                {{ value }}{{ html }}
            </router-link>
            <div v-else>
                {{ value }}
            </div>
            <slot name="default"></slot>
        </div>
    </o-field>
</template>
<script>
    import { ref, computed, inject, onMounted, onUnmounted } from "vue";
    export default {
        props: {
            label: {
                type: String,
                default: ""
            },
            value: {
                type: [String, Number, Array, Object],
                default: ""
            },
            icon: {
                type: String,
                default: ""
            },
            to: {
                type: [Object, String, null],
                default: null
            },
            href: {
                type: String,
                default: ""
            },
            loading: {
                type: Boolean,
                default: false
            },
            html: {
                type: String,
                default: ""
            }
        },
        setup(props, context) {
            const isToSpecial = computed(() => {
                return (
                    props.to &&
                    typeof props.to === "string" &&
                    (props.to.startsWith("mailto:") || props.to.startsWith("tel:"))
                );
            });

            return {
                isToSpecial
            };
        }
    };
</script>
